// extracted by mini-css-extract-plugin
module.exports = {"container":"WidgetCard_container__3XZZp","widgetItem":"WidgetCard_widgetItem__23zkm","activeDot":"WidgetCard_activeDot__1zqBs"};